:host{position:absolute;top:50%;left:20%}.handles{text-align:center;margin-bottom:.5rem}
/*# sourceMappingURL=eraser.component-3CHXIVMO.css.map */
